import { getDepartmentId, getTenantId } from 'src/app/services/store-snapshot.service';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpParams, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/core/models/api-response';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { createFilterParams } from 'src/app/shared/functions/create-filter-params';
import { IdName } from 'src/app/shared/models/id-name';
import { IUserInPositionGroup } from 'src/app/message/models/send-message.model';
import { IJobPositionGroupModel } from '../model/job-position-group.model';

@Injectable({
  providedIn: 'root',
})
export class JobPositionGroupApiService {
  private get baseUrl(): string {
    return `${environment.apiUrl}/api/${getTenantId()}/Positions/PositionGroup`;
  }

  private readonly httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
    params: new HttpParams(),
  };

  constructor(private http: HttpClient) {}

  getJobPositionGroups(
    currentFilter?: MainTableFilterModel
  ): Observable<ApiResponse<IJobPositionGroupModel[]>> {
    const params = createFilterParams(currentFilter);

    return this.http.get<ApiResponse<IJobPositionGroupModel[]>>(this.baseUrl, {
      ...this.httpOptions,
      params,
    });
  }

  getAllJobPositionGroups(): Observable<IdName[]> {
    const url = `${this.baseUrl}/List`;
    return this.http.get<IdName[]>(url);
  }

  getAllJobPositionGroupsWithPositions(): Observable<IJobPositionGroupModel[]> {
    const url = `${this.baseUrl}/ListWithPositions`;
    return this.http.get<IJobPositionGroupModel[]>(url);
  }

  addJobPositionGroup(positionGroup: IJobPositionGroupModel): Observable<IJobPositionGroupModel> {
    return this.http.post<IJobPositionGroupModel>(this.baseUrl, positionGroup, this.httpOptions);
  }

  getJobPositionGroupById(id: string): Observable<IJobPositionGroupModel> {
    const url = `${this.baseUrl}/${id}`;
    return this.http.get<IJobPositionGroupModel>(url, this.httpOptions);
  }

  getAllJobPositionGroupsForDepartment(): Observable<IdName[]> {
    const url = `${
      environment.apiUrl
    }/api/${getTenantId()}/${getDepartmentId()}/departmentScope/JobPositionGroups`;
    return this.http.get<IdName[]>(url, this.httpOptions);
  }

  updateJobPositionGroup(
    positionGroup: IJobPositionGroupModel
  ): Observable<IJobPositionGroupModel> {
    const url = `${this.baseUrl}/${positionGroup.id}`;
    return this.http.put<IJobPositionGroupModel>(url, positionGroup, this.httpOptions);
  }

  deleteJobPositionGroup(id: string): Observable<void> {
    const url = `${this.baseUrl}/${id}`;
    return this.http.delete<void>(url);
  }

  getAllJobPositionGroupsForDepartmentAndGroups(
    departmentIds?: string[],
    departmentGroupIds?: string[],
    tenantId?: string
  ): Observable<IdName[]> {
    const params: any = {
      departmentIds: departmentIds?.length ? departmentIds : [],
      departmentGroupIds: departmentGroupIds?.length ? departmentGroupIds : [],
    };
    const url = `${environment.apiUrl}/api/${
      tenantId || getTenantId()
    }/Positions/PositionGroup/departments`;
    return this.http.get<IdName[]>(url, {
      params,
    });
  }

  getUsersByPositionGroup(
    positionGroupId: string,
    departmentId: string | null
  ): Observable<IUserInPositionGroup[]> {
    const url = `${this.baseUrl}/${positionGroupId}/Users`;
    let params = new HttpParams();
    if (departmentId) {
      params = params.set('departmentId', departmentId);
    }
    return this.http.get<IUserInPositionGroup[]>(url, { params });
  }
}
